// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"styles_inputContainer__9w713 flex flex-column items-start justify-between","input":"styles_input__aRHoI lato"};